export default function SuggestionCard({ text, onClick }) {
    return (
        <button className="suggestion-card" onClick={onClick}>
            <span>{text}</span>
        </button>
    );
}
